import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=549fb68a&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=549fb68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fb68a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsLogoDesktop: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/LogoDesktop.vue').default,IconsMagnifyingGlass: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/MagnifyingGlass.vue').default,IconsPerson: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Person.vue').default,IconsHamburgerMenu: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/HamburgerMenu.vue').default,IconsHeadphone: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Headphone.vue').default,IconsCamera: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Camera.vue').default,IconsChoir: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Choir.vue').default,IconsNewspaper: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Newspaper.vue').default,DownloadLinks: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/DownloadLinks.vue').default,LayoutsMobileNavigation: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/layouts/MobileNavigation.vue').default})
